import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { DealerRentOutComponent } from './dealer-rent-out.component';
import { AuthGuard } from 'src/app/auth/auth.guard';
import { ProviderRentOfferComponent } from '../provider/provider-rent-offer/provider-rent-offer.component';
import { ProviderRentComponent } from '../provider/provider-rent/provider-rent.component';
import { NotFoundComponent } from 'src/app/auth/not-found/not-found.component';
import { TransactionStage } from 'src/app/public/common/constants/common-basic-data';

const routes: Routes = [
  { path: '', component: DealerRentOutComponent,
    children: [

      { path: 'offer', canActivate: [AuthGuard], component: ProviderRentOfferComponent },
      { path: 'bookings', canActivate: [AuthGuard], component: ProviderRentComponent, data: { transactionStages: [ TransactionStage.CONFIRMED ] }   },
      { path: 'ongoing', canActivate: [AuthGuard], component: ProviderRentComponent, data: { transactionStages: [ TransactionStage.ONGOING ] }  },
      { path: 'completed', canActivate: [AuthGuard], component: ProviderRentComponent, data: { transactionStages: [ TransactionStage.COMPLETED ] }   },

      { path: '**', component: NotFoundComponent },
    ]
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class DealerRentOutRoutingModule { }
